import React from 'react';
import macroOverviewIcon from '@/imgs/MacroEnv/macro-overview-icon.png';
import economicGrowthIcon from '@/imgs/MacroEnv/economic-growth-icon.png';
import inflationIcon from '@/imgs/MacroEnv/inflation-icon.png';
import monetaryPolicyIcon from '@/imgs/MacroEnv/monetary-policy-icon.png';
import marketSentimentIcon from '@/imgs/MacroEnv/market-sentiment-icon.png';
interface MacroIndicator {
  icon: string;
  title: string;
  subtitle: string;
}

interface MacroEnvProps {
  className?: string;
  indicators?: MacroIndicator[];
}

const MacroEnv: React.FC<MacroEnvProps> = ({ className = '', indicators: customIndicators }) => {
  const defaultIndicators: MacroIndicator[] = [
    {
      icon: economicGrowthIcon,
      title: '经济增长',
      subtitle: '稳定'
    },
    {
      icon: inflationIcon,
      title: '通货膨胀',
      subtitle: '较低'
    },
    {
      icon: monetaryPolicyIcon,
      title: '货币政策',
      subtitle: '稳健'
    },
    {
      icon: marketSentimentIcon,
      title: '市场情绪',
      subtitle: '改善'
    }
  ];

  const indicators = customIndicators || defaultIndicators;

  return (
    <div className={`flex flex-col gap-3 ${className} mt-4 w-full`}>
      {/* 标题区域 */}
      <div className="flex items-center gap-1">
        <div className="h-6rounded flex w-6 items-center justify-center">
          <img src={macroOverviewIcon} alt="宏观环境" className="h-6 w-6 object-cover" />
        </div>
        <h3 className="text-base font-semibold text-black">宏观市场环境分析</h3>
      </div>

      {/* 指标卡片区域 */}
      <div className="flex justify-between gap-2.5 rounded-lg bg-white p-4">
        {indicators.map((indicator, index) => (
          <div key={index} className="w-21 flex flex-col items-center justify-center gap-1">
            {/* 图标容器 */}
            <div className="flex h-[30px] w-[30px] items-center justify-center rounded bg-white">
              <img
                src={indicator.icon}
                alt={indicator.title}
                className="h-full w-full object-contain"
              />
            </div>

            {/* 文字内容 */}
            <div className="text-center">
              <div className="text-sm font-normal leading-5 text-[#1F1F1F]">{indicator.title}</div>
              <div className="text-sm font-normal leading-5 text-[#5959EB]">
                {indicator.subtitle}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MacroEnv;
